import { render, staticRenderFns } from "./bienes.view.vue?vue&type=template&id=0b373387"
import script from "./bienes.view.vue?vue&type=script&lang=js"
export * from "./bienes.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports